var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { identity } from 'fp-ts/lib/function';
import { concat, of, Subject } from 'rxjs';
import { delay, mergeMap, scan, switchMap } from 'rxjs/operators';
import { v4 as uuid } from 'uuid';
var ToastService = /** @class */ (function () {
    function ToastService() {
        var _this = this;
        this.toastsMap = new Map();
        this.actions$ = new Subject();
        this.toasts$ = this.actions$.pipe(mergeMap(function (action) { return action; }), scan(function (toasts, action) {
            if ('enter' in action) {
                var newToast_1 = __assign(__assign({}, action.enter), { visible: true });
                return toasts.some(function (t) { return t.key === action.enter.key; })
                    ? toasts.map(function (t) { return (t.key === action.enter.key ? newToast_1 : t); })
                    : __spreadArray(__spreadArray([], toasts, true), [newToast_1], false);
            }
            else if ('hide' in action) {
                return toasts.map(function (t) {
                    return t.key === action.hide.key
                        ? __assign(__assign({}, t), { visible: false }) : t;
                });
            }
            else {
                var key = action.leave.key;
                var subj$ = _this.toastsMap.get(key);
                if (subj$) {
                    subj$.complete();
                    _this.toastsMap.delete(key);
                }
                return toasts.filter(function (t) { return t.key !== action.leave.key; });
            }
        }, []));
    }
    ToastService.prototype.acceptToastStream = function (key, data$) {
        var subj$ = this.toastsMap.get(key);
        if (!subj$) {
            subj$ = new Subject();
            this.toastsMap.set(key, subj$);
            this.actions$.next(subj$.pipe(switchMap(identity)));
        }
        subj$.next(data$);
    };
    ToastService.prototype.push = function (toastInfo) {
        var toast = toastInfo.key ? toastInfo : __assign(__assign({}, toastInfo), { key: uuid() });
        if (toast.fixed) {
            this.acceptToastStream(toast.key, of({ enter: toast }));
        }
        else {
            this.acceptToastStream(toast.key, concat(of({ enter: toast }), of({ hide: toast }).pipe(delay(3000)), of({ leave: toast }).pipe(delay(2000))));
        }
    };
    return ToastService;
}());
export { ToastService };
export var toastService = new ToastService();
//# sourceMappingURL=toasts.service.js.map